import { Component, Optional, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CAPICHE_AUTH_CONFIG, CapicheAuthConfig } from '../capiche-auth.config';

@Component({
  selector: 'capiche-auth-shell',
  imports: [CommonModule, RouterModule],
  templateUrl: './capiche-auth-shell.component.html',
  styleUrl: './capiche-auth-shell.component.css',
  // Default (Emulated) encapsulation — ViewEncapsulation.None was removed to
  // prevent accidental style leakage into unrelated components.
})
export class CapicheAuthShellComponent {
  /** Logo URL — set via CapicheAuthConfig.logoUrl by apps that have no
   *  persistent branded header (teacher portal). Undefined = no logo shown. */
  readonly logoUrl: string | undefined;

  constructor(@Optional() @Inject(CAPICHE_AUTH_CONFIG) config: CapicheAuthConfig | null) {
    this.logoUrl = config?.logoUrl;
  }
}
